loadjs.ready('js_default', function () {


    // working install of tabpanelwidget used in news
    var uninstall = false
    $(document).ready(function () {
        const $body = $('body');
        const $window = $('window');

        // Filter row Liste
        const filterList = $('.kw-tab');

        if (filterList.length) {
            let flr = new filterListRow(filterList, $('.kw-tab__link a'), $('.kw-tab__col'));
        }


        /* text slider header XL */
        let textslide = $('.slide-text');
        if (textslide.length) {
            new textSlide(textslide);
        }
        /* text slider header XL */

        /* header search bar*/
        let headersearch = $('.search__input');
        let headersearchcontainer = $('.search');
        headersearch.on("focus", function () {
            headersearchcontainer.addClass('focus');
            $body.addClass('search__input--open');
        });
        headersearch.on("blur", function () {
            headersearchcontainer.removeClass('focus');
            $body.removeClass('search__input--open');
        });
        /* header search bar*/


        var catwidget = $('#cat-widget');
        if (catwidget.length && window.innerWidth >= 750) {
            Tabpanelwidget.install(catwidget[0]).then(function (_) {
                uninstall = _
            })
        }

        //add to fav
        let addToFavLink = $('.btn--add-to-fav');
        if (addToFavLink.length >= 1) {
            new AddToFav();
        }

        new ShrinkedHeader();


        //formular arrow
        let form = $('.el-userform');
        if (form.length > 0) {
            let dropdownField = $('div.dropdown .middleColumn');
            if (dropdownField.length > 0) {
                dropdownField.append(
                    '<svg class="svg-item icon--arrow icon--bronze" viewBox="0 0 100 100"><use xlink:href="#icon--arrow" /></svg>'
                );
            }

        }

        const checkpoint = 300;
        let opacity;
        let btntop = $('.btn--totop');
        window.addEventListener("scroll", () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll <= checkpoint) {
                opacity = 0;
                btntop.css('z-index', -1);
            } else {
                btntop.css('z-index', 1);
                opacity = 0 + ((currentScroll - checkpoint) / 1000);
            }
            btntop.css('opacity', opacity);
        });


        //init InfoPopUp
        // if  textright class there add infoPopUp
        let rightTitle = $(".right-title")
        if (rightTitle.length > 0) {
            new InfoPopUp();
        }

        //init AlphabetScroller
        let scrollist = $("scrollist")
        if (scrollist) {
            new AlphabetScroller();
            // new CityGuide();
        }

        // init nav logic
        new Mobilenav();

        //slider
        let slide = $('.el-teaser-high__slides');
        if (slide.length >= 1) {
            slide.slick({
                dots: true,
              autoplay: true,
              autoplaySpeed: 2000,
            });
        }


        /* favoriten */
        function getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        }

        function setCookie(name, value, days) {
            var d = new Date;
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
            document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        }

        function deleteCookie(name) {
            setCookie(name, '', -1);
        }

        //fav löschen
        $('.fav-delete').click(function (e) {

            deleteCookie('FavPage', '', -1);
            $('#fav-list').hide();
            $('#no-favs').show();
            $(this).hide();
            $('.favs').removeClass('active');
            e.preventDefault();
        });


        $body.addClass('loaded');

        $('.cookie--change').click(function (e) {
            klaro.show();
            e.preventDefault();
        });

        $('.cookie--maps-allow').click(function (e) {
            allowGoogleMaps(e);
            e.preventDefault();
        });

        $('.cookie--youtube-allow').click(function (e) {
            allowYouTube(e);
            e.preventDefault();
        });


    });

    window.onresize = function () {
        if (uninstall !== false && window.innerWidth <= 750) {
            uninstall()
            uninstall = false
        } else if (window.innerWidth > 750 && uninstall == false) {
            var catwidget = $('#cat-widget');
            if (catwidget.length) {
                Tabpanelwidget.install(catwidget[0]).then(function (_) {
                    uninstall = _
                })
            }
        }

    }
    window.onscroll = function () {
        if (window.scrollY > 12) {
            $(".header").addClass("header__scrolled")
        } else {
            $(".header").removeClass("header__scrolled")
        }
    }


});
